/* eslint-disable @typescript-eslint/no-explicit-any */
import { GetServerSideProps } from 'next';

import { getProcessEnvs, PageRendererComponent, prePageCall } from '@marriott/mi-headless-utils';
import { mockModel } from '../../mocks/mockModel';
import { getContentUrl, NEXT_PUBLIC_ENV_KEYS, RESORT_CONTENT_ROOT } from '@marriott/mi-category-components';
import categorySignatures from '../../signatures/categorySignatures.json';
import { FEATURE_FLAGS, fetchFlag, TARGETS } from '@marriott/mi-feature-flag-utils';

function pageRenderer(props) {
  console.log('Category [page] props ', props);
  return <PageRendererComponent {...props} />;
}

//Any product specific page data apart from common data like session, datalayer
//can be returned from this function and the same is passed as props to the page Component
const groupSpecificData = async (context: any) => {
  console.log('Category Resort Resolved URL:', context?.resolvedUrl);
  const { GOOGLE_MAP_API_KEY } = getProcessEnvs();
  const uri = getContentUrl(context, RESORT_CONTENT_ROOT);

  // Feature flag calls
  const [featureFlags, featureFlagLogo, isNextGenSearchFormEnabled] = await Promise.all([
    fetchFlag(FEATURE_FLAGS.EXPERIENCE_MCOM_CAROUSEL_LIGHTINING_VARIANTS, {
      target: TARGETS.APP.CATEGORY_RENDERER,
    }),
    fetchFlag(FEATURE_FLAGS.EXPERIENCE_MCOM_LOGO_AUTOMATION, {
      target: TARGETS.APP.CATEGORY_RENDERER,
    }),
    fetchFlag(FEATURE_FLAGS.EXPERIENCE_MCOM_GROUPS_NEXT_GEN_SEARCH_FORM, {
      target: TARGETS.APP.CATEGORY_RENDERER,
    }),
  ]);

  const dttFlags = {
    [FEATURE_FLAGS.EXPERIENCE_MCOM_GROUPS_NEXT_GEN_SEARCH_FORM]:
      isNextGenSearchFormEnabled?.experience_mcom_groups_next_gen_search_form ?? false,
  };

  return {
    operationSignatures: categorySignatures,
    uri: uri,
    nextPublicEnvKeys: NEXT_PUBLIC_ENV_KEYS,
    GOOGLE_MAP_API_KEY,
    featureFlags: { featureFlagLogo, featureFlags },
    dttFlags,
  };
};

//Make pre page calls like session, datalayer, fetch model.json, producSpecifc data etc
//at server side and pass the data is passed as props to page component.
export const getServerSideProps: GetServerSideProps<any> = prePageCall(groupSpecificData, mockModel);
export default pageRenderer;
